<template>
  <article class="hotel-card">
    <div class="hotel-card__left">
      <div class="hotel-card__photo">
        <div src="" alt="Hotel Image" class="hotel-card__image"></div>
      </div>
      <div class="hotel-card__details">
        <header class="hotel-card__header">
          <h2 class="hotel-card__title"></h2>
          <div class="hotel-card__location">
            <span class="hotel-card__location-icon"></span>
          </div>
        </header>
        <section class="hotel-card__info">
          <div class="hotel-card__amenities"></div>
          <div class="hotel-card__conditions">
            <div class="hotel-card__condition"></div>
            <div class="hotel-card__condition"></div>
          </div>
        </section>
      </div>
    </div>
    <div class="hotel-card__right">
      <div class="hotel-card__rating-price">
        <div class="hotel-card__valuation"></div>
        <div class="hotel-card__action">
          <div class="hotel-card__price">
            <div class="hotel-card__per-night"></div>
            <div class="hotel-card__taxes"></div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HotelCard',
  // Add any necessary component logic here
});
</script>

<style scoped lang="scss">
$border-color: var(--grey-border);
$background-color: var(--white);
$image-background: var(--grey);
$placeholder-background: var(--grey-loader-additional);
$shimmer-duration: 1.6s;

@mixin shimmer($base-color) {
  background-color: $base-color;
  background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.35) 50%, rgba(255, 255, 255, 0) 100%);
  background-size: 200% 100%;
  background-repeat: no-repeat;
  animation: shimmer $shimmer-duration ease-in-out infinite;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.hotel-card {
  display: flex;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 6px;
  border: 2px solid $border-color;
  background: $background-color;

}

.hotel-card__left {
  display: flex;
  min-width: 240px;
  justify-content: flex-start;
  flex-wrap: wrap;
  height: 100%;
  flex: 1;
  flex-basis: 20px;
}

.hotel-card__photo {
  border-radius: 6px 0 0 6px;
  display: flex;
  min-width: 240px;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
  flex-basis: 24px;
  max-width: 262px;
  margin: -2px 0 -2px -2px;

  @media (max-width: 768px) {
    max-width: 131px;
    min-width: 131px;
    border-radius: 10px 0 0 0;
  }
}

.hotel-card__image {
  @include shimmer($image-background);
  height: 236px;
  width: 100%;
  object-fit: cover;
}

.hotel-card__details {
  align-self: flex-start;
  display: flex;
  min-width: 269px;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  flex-basis: 0%;
  padding: 20px 0 20px 24px;

  @media (max-width: 768px) {
    min-width: auto;
    padding: 12px 16px 16px 16px;
  }
}

.hotel-card__header {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
}

.hotel-card__title {
  border-radius: 25px;
  @include shimmer($placeholder-background);
  min-height: 24px;
  width: 100%;
}

.hotel-card__location {
  align-items: flex-start;
  border-radius: 25px;
  @include shimmer($placeholder-background);
  display: flex;
  margin-top: 8px;
  width: 100%;
  gap: 8px;
  justify-content: flex-start;
}

.hotel-card__location-icon {
  display: flex;
  min-height: 18px;
  width: 18px;
  border-radius: 50%;
  @include shimmer($placeholder-background);
}

.hotel-card__info {
  display: flex;
  margin-top: 12px;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
}

.hotel-card__amenities {
  border-radius: 10px;
  @include shimmer($placeholder-background);
  min-height: 20px;
  width: 100%;
  gap: 4px 16px;
}

.hotel-card__conditions {
  display: flex;
  margin-top: 12px;
  width: 168px;
  max-width: 100%;
  flex-direction: column;
  justify-content: flex-start;
}

.hotel-card__condition {
  border-radius: 25px;
  @include shimmer($placeholder-background);
  min-height: 20px;
  width: 100%;
  gap: 8px;
}

.hotel-card__condition:last-child {
  margin-top: 4px;
}

.hotel-card__right {
  display: flex;
  min-height: 232px;
  gap: 12px;
  justify-content: flex-start;
  width: 189px;
  margin: auto 0;
  padding: 20px 20px 20px 0;

  @media (max-width: 768px) {
    min-height: auto;
    width: 100%;
    padding: 20px 16px;
  }
}

.hotel-card__rating-price {
  display: flex;
  width: 155px;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: row;
    align-items: flex-start;
  }
}

.hotel-card__valuation {
  border-radius: 10px;
  @include shimmer($placeholder-background);
  min-height: 40px;
  width: 120px;
  max-width: 100%;
  gap: 8px;
}

.hotel-card__action {
  display: flex;
  margin-top: 108px;
  width: 116px;
  max-width: 100%;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
}

.hotel-card__price {
  border-radius: 25px;
  display: flex;
  width: 100%;
  max-width: 116px;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  @include shimmer($placeholder-background);
}

.hotel-card__per-night {
  border-radius: 25px;
  @include shimmer($placeholder-background);
  min-height: 24px;
  gap: 4px;
}

.hotel-card__taxes {
  border-radius: 25px;
  @include shimmer($placeholder-background);
  min-height: 16px;
  margin-top: 4px;
}

@media (max-width: 991px) {
  .hotel-card__left {
    max-width: 100%;
    border-bottom: 3px solid $border-color;
  }

  .hotel-card__action {
    margin-top: 0;
  }
}
</style>
